import React, { useEffect, useState } from "react";
import Button from "../../../../component/button/Button";
import Input from "../../../../component/input/Input";
// import Select, { ValueContainerProps, components } from "react-select";
import { useLocation, useParams } from "react-router-dom";
import Select from "../../../../component/multiSelect/MultiSelect";
import { useSelector } from "react-redux";
import useClientConfig from "../../../../config/careers/clientConfig";
import Image from "../../../../component/image/Image";
import searchIcon from "../../../../assets/images/search-job-new.svg";


const OptionFourJobFilter = (props: any) => {
    const location = useLocation();
    const routeParams = useParams();

    const cliendConfig = useSelector((state: any) => state.careers.cliendConfig);
    const langLabels = cliendConfig?.data?.data?.clientSettings?.languageSettings;
    const searchLangLabels = langLabels?.searchSection?.[0];
    const {clientSiteSettings} = useClientConfig();
    const templateName = clientSiteSettings?.templateName;
    const [showClearBtn, setShowClearBtn] = useState(false);
  

    const { filter, checkListControl, tableControl, searchControlSubmit, setTableControl, removeSearchForm } = props;
    const submitSearch = () => {
        if(tableControl?.searchText !== ""){
            setShowClearBtn(true); // added to avoid show clear button when search text is empty
        }else{
            setShowClearBtn(false);
        }
        searchControlSubmit();
    };

    useEffect(() => {
        let searchInputField = document.getElementById("Search") as HTMLInputElement;
        let searchKeyWord = searchInputField?.value;
        if (tableControl?.searchText !== "" || searchKeyWord !== "") {
            setShowClearBtn(true);
        } else {
            setShowClearBtn(false);
        }
    }, []);
    

    
    return (
        
        <div className="option4-job-search-box-parent">
            <div className={`job-search-box option4-job-search-box ${location.pathname === `/view/${routeParams?.id}` ? "filter-background1" : ""}`}>
                <div className="d-flex align-items-center d-flex-search-job">
                    {/* <i className="pi pi-search top-search fw-bolder pe-2"></i> */}
                    <h2 className="search-job mb-0">
                        <Image src={searchIcon} /> {searchLangLabels?.searchJobs}
                    </h2>

                    {/* && jobsList?.data?.data?.jobs?.item?.length > 0  */}
                    {location.pathname !== `/view/${routeParams?.id}` && checkListControl && showClearBtn ?
                        <div className="btn-clear-filter">
                            <Button onClick={() => removeSearchForm()} clasName="btn completion-btn-primary" icon={"pi pi-times custom-close-filter"} position="left" label={"Clear Filters"} />
                        </div>
                        :
                        ""
                    }

                </div>
                <div className="form-group search-bg-form-group position-relative common-before-icon search-icon">
                    {/* <Image src={JobSearch} clasName="filer-search-icon" /> */}
                    <i className="pi pi-search  fw-bolder filer-search-icon"></i>

                    <Input
                        className={`form-control active filter-in ${tableControl.searchText ? "filter-in-active" : ""}`}
                        type={"text"}
                        value={tableControl.searchText}
                        placeholder={clientSiteSettings?.templateName === "template_10" ? "Search by Job Title, Keywords.." : searchLangLabels?.searchPlaceholder+"..."}
                        name={searchLangLabels?.search}
                        onChange={(e: { target: { value: any; }; }) => {
                            setTableControl((prs: any) => {
                                return {
                                    ...prs,
                                    searchText: e.target.value
                                };
                            });
                        }
                        }
                    />
                </div>

                <div className="btn-section">
                    <Button
                        clasName="btn-new btn-primary-new"
                        label={searchLangLabels?.search}
                        position="left"
                        icon="pi pi-search"
                        onClick={() => submitSearch()}
                    />
                </div>
            </div>
        </div>
            
        
    );
};

export default OptionFourJobFilter;